import { PERSISTED_SHAPE_INFO, LOADED_PERSISTED_SHAPE } from '../actions/actionTypes';

const initialState = {
  isLoadedPersistedShape: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case PERSISTED_SHAPE_INFO: {
    return {
      ...action.payload.shapes,
      isLoadedPersistedShape: false,
    };
  }
  case LOADED_PERSISTED_SHAPE: {
    return {
      ...state,
      isLoadedPersistedShape: true,
    };
  }
  default:
    return state;
  }
};
